import styled, { css } from 'styled-components';
import { space, width, height } from 'styled-system';
import FormControl from '@mui/material/FormControl';
// helpers
import * as G from '../../helpers';
//////////////////////////////////////////////////

const azureColor = G.getTheme('colors.azure');
const darkGreyColor = G.getTheme('colors.dark.grey');
const mainDarkColor = G.getTheme('colors.light.mainDark');

const StyledFormControl = styled(FormControl)`
  ${space}
  ${width}
  ${height}

  & .MuiSelect-icon {
    display: none;
  }

  & .MuiSelect-multiple {
    cursor: text;
  }

  & .MuiFormLabel-root {
    font-size: 12px;
  }

  & .MuiOutlinedInput-root {
    height: 32px;
    font-size: 12px;

    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${darkGreyColor};
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: ${darkGreyColor};
    }
  }

  ${({ useDarkColor, focusedOrHasValue }) => focusedOrHasValue && css`
    & .MuiFormLabel-root {
      top: 2px;
      color: ${G.ifElse(useDarkColor, mainDarkColor, azureColor)};
    }

    & .MuiOutlinedInput-root {
      &:hover {
        .MuiOutlinedInput-notchedOutline {
          border-color: ${G.ifElse(useDarkColor, mainDarkColor, azureColor)};
        }
      }

      .MuiOutlinedInput-notchedOutline {
        border-width: 1px;
        border-color: ${G.ifElse(useDarkColor, mainDarkColor, azureColor)};
      }
    }
  `}
`;

StyledFormControl.defaultProps = {
  width: 180,
  height: 32,
};

export {
  StyledFormControl,
};
